import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import LoginPage from "./pages/auth/LoginPage";
import RegisterAccountPage from "./pages/auth/registration/RegisterAccountPage";
import LogoutPage from "./pages/auth/LogoutPage";
import Layout from "./navigations/Routes";
import DashboardPage from "./pages/dashboard/DashboardPage";
import EditProfilePage from "./pages/userProfile/EditProfilePage";
import ParliamentOfMalaysiaHansardPage from "./pages/resourceCentre/parliamentOfMalaysiaHansard/ParliamentOfMalaysiaHansardPage";
import LatinDictionaryPage from "./pages/latinDictionary/LatinDictionaryPage";
import TermPage from "./pages/term/TermPage";
import FederalAndStates from "./pages/eGazette/federal&states/FederalAndStates";
import LocalMunicipalCouncil from "./pages/eGazette/localMunicipalCouncil/LocalMunicipalCouncil";
import Selangor from "./pages/eGazette/federal&states/Selangor/localMunicipal/Selayang/LocalMunicipalCouncilState";
import MedalHonours from "./pages/eGazette/medalHonours/MedalHonours";
import MedalFederalPage from "./pages/eGazette/medalHonours/federal&states/DatukshipState/DatukshipState";
import IndustrialRelationPage from "./pages/caseLaw/industrialRelation/IndustrialRelationPage";
import SyariahPage from "./pages/caseLaw/syariah/SyariahPage";
import SelayangPage from "./pages/eGazette/federal&states/Selangor/localMunicipal/Selayang/Selayang";
import SafetyHealthPage from "./pages/safetyHealth/safetyHealth";
import EgazetteSearch from "./pages/eGazette/search/Search";
import LawLibrarySearch from "./pages/lawLibrary/Search";
import CivilAndCriminal from "./pages/caseLaw/civil-and-criminal/CivilAndCriminal";
import CaseSummary from "./pages/caseLaw/CaseSummary";
import DocumentRouter from "./components/DocumentRouter";
import HomePage from "./pages/landingPages/HomePage";
import PrivacyPolicy from "./pages/landingPages/PrivacyPolicy";
import PrivateRoute from "./pages/auth/ProtectedRouting";
import { GazetteProvider } from "./context/GazetteContext";
import LawLibraryV2 from "./pages/lawLibrary/LawLibraryV2";
import WartaLoginPage from "./pages/eWarta/auth/LoginPage";
import GazetteFinder from "./pages/eWarta/gazetteFinder/GazetteFinder";
import WartaLayout from "./pages/eWarta/component/Layout";
import FrequentHistory from "./pages/eWarta/frequentHistory/FrequentHistory";
import PurchaseHistory from "./pages/eWarta/purchaseHistory/PurchaseHistory";
import SearchHistory from "./pages/eWarta/searchHistory/SearchHistory";
import Cart from "./pages/eWarta/cart/Cart";
import { WartaProvider } from "./context/WartaContext";
// import Checkout from "./pages/eWarta/cart/Checkout";
import Result from "./pages/eWarta/gazetteFinder/Result";
import WartaState from "./pages/eWarta/gazetteFinder/WartaState";
import Inbox from "./pages/eWarta/inbox/Inbox";
import InboxNotification from "./pages/inbox/InboxNotification";
import Index from "./pages/index/Index";
import Requests from "./pages/eWarta/requests/RequestList";
import UserProfile from "./pages/userProfile/UserProfile";
import PaymentMethod from "./pages/auth/payment/PaymentMethod";
import PaymentResponse from "./pages/auth/payment/PaymentResponse";
import UploadDocument from "./pages/auth/payment/UploadDocument";
import LandLaw from "./pages/eGazette/landLaw/LandLaw";
import LandLawState from "./pages/eGazette/landLaw/LandLawState";
import LibraryProviderLayout from "./components/LibraryProviderLayout";
import Bookmark from "./pages/bookmarks/Bookmarks";
import ActivatePage from "./pages/auth/payment/Activate";
import ScrollToTop from "./components/ScrollToTop";
import MobilePrivacyPolicy from "./pages/landingPages/MobilePrivacyPolicy";
import FormsCausePapers from "./pages/lawLibrary/FormsCausePapers";
import QutoationResponse from "./pages/auth/payment/QuotationResponse";
import InvoiceResponse from "./pages/auth/payment/InvoiceResponse";

const App = () => {
  return (
    <>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/activate" element={<ActivatePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route
            path="/mobile-privacy-policy"
            element={<MobilePrivacyPolicy />}
          />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterAccountPage />} />
          <Route path="/payment" element={<PaymentMethod />} />
          <Route path="/quotation" element={<QutoationResponse />} />
          <Route path="/invoice" element={<InvoiceResponse />} />
          <Route path="/payment-result" element={<PaymentResponse />} />
          <Route path="/upload-document" element={<UploadDocument />} />

          <Route path="/logout-success" element={<LogoutPage />} />
          <Route
            path="/eWarta"
            element={<Navigate to="/eWarta/login" replace />}
          />
          <Route path="/eWarta/login" element={<WartaLoginPage />} />
          <Route
            path="/eWarta"
            element={
              <WartaProvider>
                <WartaLayout />
              </WartaProvider>
            }
          >
            <Route path="requests" element={<Requests />} />
            <Route path="requests/:requestId" element={<Result />} />

            <Route path="gazetteFinder" element={<GazetteFinder />} />
            <Route path="gazetteFinder/:stateName" element={<WartaState />} />
            <Route path="frequentHistory" element={<FrequentHistory />} />
            <Route path="purchaseHistory" element={<PurchaseHistory />} />
            <Route path="searchHistory" element={<SearchHistory />} />
            <Route path="cart" element={<Cart />} />
            <Route path="inbox" element={<Inbox />} />
          </Route>
          <Route>
            <Route path="/" element={<Layout />}>
              <Route
                path="dashboard"
                element={<PrivateRoute element={<DashboardPage />} />}
              />
              <Route
                path="user-profile"
                element={<PrivateRoute element={<UserProfile />} />}
              />

              <Route
                path="edit-user-profile"
                element={<PrivateRoute element={<EditProfilePage />} />}
              />
              <Route
                path="resource-centre/:resourceId"
                element={
                  <PrivateRoute element={<ParliamentOfMalaysiaHansardPage />} />
                }
              />
              <Route
                path="latin-dictionary"
                element={<PrivateRoute element={<LatinDictionaryPage />} />}
              />
              <Route
                path="term"
                element={<PrivateRoute element={<TermPage />} />}
              />
              {/* <Route
                path="index"
                element={<PrivateRoute element={<Index />} />}
              /> */}
              <Route element={<LibraryProviderLayout />}>
                <Route
                  path="safety-health-environment"
                  element={<PrivateRoute element={<SafetyHealthPage />} />}
                />
                <Route
                  path="user/inboxnotif"
                  element={<PrivateRoute element={<InboxNotification />} />}
                />
                <Route
                  path="user/bookmark"
                  element={<PrivateRoute element={<Bookmark />} />}
                />
                <Route
                  path="law-library/*"
                  element={
                    <PrivateRoute
                      element={
                        <Routes>
                          <Route path="" element={<LawLibraryV2 />} />
                          <Route path="search" element={<LawLibrarySearch />} />
                          <Route path="document" element={<DocumentRouter />} />
                          <Route
                            path="formsCausePapers/:stateId"
                            element={<FormsCausePapers />}
                          />
                          <Route
                            path="formsCausePapers/states"
                            element={<FormsCausePapers />}
                          />
                        </Routes>
                      }
                    />
                  }
                />
              </Route>

              <Route
                path="e-gazette/*"
                element={
                  <GazetteProvider>
                    <Routes>
                      <Route
                        path="federal-&-states"
                        element={
                          <PrivateRoute element={<FederalAndStates />} />
                        }
                      />
                      <Route
                        path="search"
                        element={<PrivateRoute element={<EgazetteSearch />} />}
                      />
                    </Routes>
                  </GazetteProvider>
                }
              />
              <Route
                path="e-gazette/local-municipal-council"
                element={<PrivateRoute element={<LocalMunicipalCouncil />} />}
              />
              <Route
                path="e-gazette/local-municipal-council/:stateId"
                element={<PrivateRoute element={<Selangor />} />}
              />
              <Route
                path="e-gazette/local-municipal-council/:stateId/:pbtId"
                element={<PrivateRoute element={<SelayangPage />} />}
              />
              <Route
                path="e-gazette/land-laws"
                element={<PrivateRoute element={<LandLaw />} />}
              />
              <Route
                path="e-gazette/land-laws/:stateId"
                element={<PrivateRoute element={<LandLawState />} />}
              />
              <Route
                path="e-gazette/medal-honours"
                element={<PrivateRoute element={<MedalHonours />} />}
              />
              <Route
                path="e-gazette/medal-honours/:stateId"
                element={<PrivateRoute element={<MedalFederalPage />} />}
              />
              <Route
                path="case-law"
                element={<PrivateRoute element={<CivilAndCriminal />} />}
              />
              {/* <Route
                path="case-law/syariah"
                element={<PrivateRoute element={<SyariahPage />} />}
              />
              <Route
                path="case-law/industrial-relation"
                element={<PrivateRoute element={<IndustrialRelationPage />} />}
              /> */}
              <Route
                path="case-law/case-summary"
                element={<PrivateRoute element={<CaseSummary />} />}
              />
              {/* <Route
                path="safety-health-environment"
                element={
                  <PrivateRoute
                    element={
                      <LibraryProvider>
                        <Routes>
                          <Route path="" element={<SafetyHealthPage />} />
                        </Routes>
                      </LibraryProvider>
                    }
                  />
                }
              /> */}
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
      {/* <BrowserRouter>
        <Routes>
          <Route path="/[EGAnchorURL]" element={<Download />} />
        </Routes>
      </BrowserRouter> */}
    </>
  );
};

export default App;
